import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, PageHeader } from "@/components/kit";
import { ROLE_LABEL } from "@/lib/auth";
import { Check, X } from "@phosphor-icons/react";

const ACTIONS = ["view", "create", "update", "delete"];

export default function PermissionsPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/permissions").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <div className="p-8 text-slate-500">Loading…</div>;

  const resources = Object.keys(data.matrix);

  return (
    <div className="max-w-6xl mx-auto p-4 md:p-8 pb-24 md:pb-8 fade-up">
      <PageHeader
        title="Permissions"
        subtitle="Role-based access matrix. Roles are hierarchical: Super Admin > Branch Admin > Agent > Staff."
      />
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-6">
        {data.roles.map((r) => (
          <Card key={r} className="p-4">
            <div className="text-[11px] uppercase tracking-widest text-slate-400 font-semibold mb-1">Role</div>
            <div className="heading font-semibold text-slate-900">{ROLE_LABEL[r]}</div>
            <div className="mono text-xs text-slate-500 mt-1">{r}</div>
          </Card>
        ))}
      </div>

      <Card>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
              <tr>
                <th className="text-left px-4 py-3">Resource</th>
                <th className="text-left px-4 py-3">Action</th>
                {data.roles.map((r) => (
                  <th key={r} className="text-center px-4 py-3">{ROLE_LABEL[r]}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {resources.map((res) => (
                ACTIONS.map((act, i) => (
                  <tr key={`${res}-${act}`} className={`border-t border-slate-100 ${i === 0 ? "bg-slate-50/30" : ""}`}>
                    {i === 0 ? (
                      <td rowSpan={ACTIONS.length} className="px-4 py-2 font-semibold capitalize align-top border-r border-slate-100">
                        {res}
                      </td>
                    ) : null}
                    <td className="px-4 py-2 capitalize text-slate-600">{act}</td>
                    {data.roles.map((role) => {
                      const allowed = (data.matrix[res][act] || []).includes(role);
                      return (
                        <td key={role} className="px-4 py-2 text-center" data-testid={`perm-${res}-${act}-${role}`}>
                          {allowed ? (
                            <Check size={16} weight="bold" className="inline text-emerald-600" />
                          ) : (
                            <X size={16} weight="bold" className="inline text-slate-300" />
                          )}
                        </td>
                      );
                    })}
                  </tr>
                ))
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
